import script from "./RTBCampaignForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RTBCampaignForm.vue?vue&type=script&setup=true&lang=js"

import "./RTBCampaignForm.vue?vue&type=style&index=0&id=8f118edc&lang=scss"

const __exports__ = script;

export default __exports__